// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IntellicheckUploadStep } from '../intellicheck-upload-step';
import { IntellicheckUploadComponentBase } from '../intellicheck-upload-component-base';
import { IDScanResult, RequestedScanType } from '../id-scan-logging';

@Component({
    selector: 'app-intellicheck-license-back',
    templateUrl: '../license-front/intellicheck-license-front.component.html',
    styleUrls: ['../intellicheck-upload.component.scss'],
})
export class IntellicheckLicenseBackComponent extends IntellicheckUploadComponentBase implements OnInit, AfterViewInit {
    @ViewChild('uploadPreview') previewCanvas: ElementRef<HTMLCanvasElement>;
    private previewCanvasContext: CanvasRenderingContext2D;

    @ViewChild('manualInput') fallbackInput: ElementRef<HTMLInputElement>;
    @Input() pageTitle: string;
    protected moduleElementName = 'idn-license-capture-back';
    public moduleName = 'LicenseCaptureFrontNativeCamera';
    protected imageDataFieldName = 'backData';
    private startScanTime: Date;

    private base64Image: string;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.doneLoading.emit();
        this.pageTitle = this.pageDefaultOverride !== null && this.pageDefaultOverride?.active ? this.pageDefaultOverride.backTitle : 'License Back';
    }

    ngAfterViewInit(): void {
        this.previewCanvasContext = this.previewCanvas.nativeElement.getContext('2d');
    }

    startCapture() {}

    continue() {
        this.captureComplete.emit({ backData: this.base64Image });
    }

    recapture() {
        this.step = IntellicheckUploadStep.Begin;
    }

    startImageCapture() {
        this.startScanTime = new Date();
        this.fallbackInput.nativeElement.click();
    }

    onImageCapture(overrideImage: File) {
        this.pushScanResults(IDScanResult.Success);
        this.displayUploadPreview(overrideImage);
    }

    pushScanResults = (result: IDScanResult) => {
        this.logScanAtttempt.emit({
            type: RequestedScanType.Back,
            typeName: RequestedScanType[RequestedScanType.Back],
            moduleName: this.moduleName,
            startTime: this.startScanTime,
            endTime: new Date(),
            elapsedMilliseconds: new Date().getTime() - this.startScanTime.getTime(),
            result: result,
            resultName: IDScanResult[result],
            data: null,
            dealerId: null,
            dealId: null,
            docId: null,
        });
    };

    displayUploadPreview(imageFile) {
        const canvas = this.previewCanvas.nativeElement;
        const image = new Image();
        this.step = IntellicheckUploadStep.Preview;
        const reader = new FileReader();
        reader.onload = (event) => {
            const dataString = event.target.result as string;
            image.src = dataString;
            this.base64Image = dataString.split(',')[1];
        };
        reader.readAsDataURL(imageFile);

        image.onload = () => {
            canvas.width = image.width;
            canvas.height = image.height;
            canvas.style.maxWidth = image.width.toString() + 'px';
            this.previewCanvasContext.drawImage(image, 0, 0, image.width, image.height);
        };
    }
}
